 import { motion } from "framer-motion";
 import { ramadanPeriods, getPeriodForDay } from "@/data/dailyDuas";
 
 interface PeriodCardsProps {
   currentDay: number;
 }
 
 export const PeriodCards = ({ currentDay }: PeriodCardsProps) => {
   const currentPeriod = getPeriodForDay(currentDay);
 
   return (
     <section className="space-y-3">
       <h2 className="text-xs uppercase tracking-[0.2em] text-muted-foreground px-1 text-center">
         The Three Periods
       </h2>
       <div className="grid grid-cols-3 gap-3">
         {ramadanPeriods.map((period, index) => {
           const isActive = currentPeriod?.id === period.id;
           
           return (
             <motion.div
               key={period.id}
               initial={{ opacity: 0, y: 10 }}
               animate={{ opacity: 1, y: 0 }}
               transition={{ delay: index * 0.05 }}
               className={`p-4 rounded-lg text-left transition-all ${
                 isActive 
                   ? 'bg-primary/10 border-2 border-primary/50' 
                   : 'bg-card border border-border/30 opacity-60'
               }`}
             >
               <p className="text-xs text-muted-foreground mb-1">{period.days}</p>
               <p className="font-display text-sm md:text-base text-foreground leading-tight">
                 {period.name}
               </p>
               <p className={`text-xs mt-1 font-arabic ${isActive ? 'text-primary' : 'text-muted-foreground'}`}>
                 {period.theme}
               </p>
             </motion.div>
           );
         })}
       </div>
     </section>
   );
 };